var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view-tenant-detail"}},[_c('p',{staticClass:"vtd-title px-2"},[_vm._v(_vm._s(_vm.vtdTitle))]),_c('p',{staticClass:"vtd-subtitle px-2"},[_vm._v(_vm._s(_vm.vtdSubtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }